import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { web_max_width } from '@common/styles';
import { NAVIGATION_HEIGHT } from '@domains/storehome-common';

export const ScrollWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  background-color: ${vars.color.staticWhite};
  min-height: 100vh;
`;

export const Divider = styled.hr`
  margin: 0;
  border: 0;
  background-color: ${vars.v3Color.gray100};
  padding: 0;
  width: 100%;
  height: 8px;
  z-index: 10;
`;

export const SearchLinkWrap = styled.div`
  padding: 8px 16px;
  background-color: ${vars.color.staticWhite};
  z-index: 10;
`;

export const SearchLink = styled.a`
  display: flex;
  align-items: center;
  height: 36px;
  padding: 6px 16px;
  border-radius: 100px;
  background-color: ${vars.v3Color.gray100};
  cursor: pointer;

  span {
    color: ${vars.color.gray300};
  }
`;

export const SearchTriggerWrap = styled.div`
  padding: 16px 16px 24px;
`;

export const TextTabWrapper = styled.div`
  position: sticky;
  top: ${NAVIGATION_HEIGHT}px;
  z-index: 20;
  border-bottom: 1px solid ${vars.color.dividerThin};

  button[data-selected] {
    color: ${vars.color.textTertiary};
  }
`;

export const SelectedTextTabWrapper = styled.div`
  position: fixed;
  top: ${NAVIGATION_HEIGHT}px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
  width: 100%;
  max-width: ${web_max_width}px;

  button {
    opacity: 0.8;
  }

  > div > div {
    transition: background-color 0.2s ease-in-out;
  }
`;
